// ============================================================
// Client axios dédié au Super Admin — Lot L04 du plan SaaS
// ============================================================
//
// Séparé de services/api.js pour ne pas mélanger les sessions :
//   - Tokens user      : sv_access_token / sv_refresh_token  (localStorage)
//   - Tokens superadmin: sv_sa_access_token / sv_sa_refresh_token (idem)
//
// Pas d'auto-refresh si le token user expire (le SA et le user peuvent
// tout à fait être ouverts dans deux onglets différents). Cette
// instance gère uniquement le refresh des tokens superadmin.
// ============================================================

import axios from 'axios';

function resolveApiBaseUrl() {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv && fromEnv.trim().length > 0) return fromEnv;
  if (typeof window === 'undefined') return 'http://localhost:5000/api';
  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}:5000/api`;
}

const API_BASE_URL = resolveApiBaseUrl();

const superAdminApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
});

superAdminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('sv_sa_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

superAdminApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      error.response?.data?.code === 'TOKEN_EXPIRED' &&
      !original._retry
    ) {
      original._retry = true;
      const refreshToken = localStorage.getItem('sv_sa_refresh_token');
      if (refreshToken) {
        try {
          const { data } = await axios.post(
            `${API_BASE_URL}/superadmin/auth/refresh`,
            { refreshToken }
          );
          localStorage.setItem('sv_sa_access_token', data.accessToken);
          original.headers.Authorization = `Bearer ${data.accessToken}`;
          return superAdminApi(original);
        } catch (_) {
          localStorage.removeItem('sv_sa_access_token');
          localStorage.removeItem('sv_sa_refresh_token');
          window.location.href = '/superadmin/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default superAdminApi;
